import { ref, computed } from 'vue';
import { useToast } from '@/composables/common/useToast';
import { t } from '@/utils/i18n-helper';
import store from '@/store';
import { config } from '@/config.js';

export function useSendTicket() {
    const toast = useToast();

    const email    = ref('');
    const nombre   = ref('');
    const apellidos = ref('');
    const loading  = ref(false);
    const error    = ref(null);

    // Simple email format check
    const emailValid = computed(() => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email.value);
    });

    const isValid = computed(() =>
        emailValid.value &&
        nombre.value.trim().length > 0 &&
        apellidos.value.trim().length > 0
    );

    const send = async({ pedidoId, qrCodes }) => {
        if (loading.value) return false;

        loading.value = true;
        error.value = null;

        try {
            await store.dispatch(
                config.getVuexAlias('front.perfil.ticket.send'),
                {
                    user_order_id: pedidoId,
                    email: email.value,
                    nombre: nombre.value,
                    apellidos: apellidos.value,
                    qr_codes: qrCodes,
                }
            );
            toast.success(t('perfil.entradas_enviadas'));
            return true;
        } catch (err) {
            const message = err.response?.data?.message || 'Error al enviar entradas';
            error.value = message;
            toast.error(message);
            return false;
        } finally {
            loading.value = false;
        }
    };

    const reset = () => {
        email.value    = '';
        nombre.value   = '';
        apellidos.value = '';
        loading.value  = false;
        error.value    = null;
    };

    return { email, nombre, apellidos, isValid, loading, error, send, reset };
}
